export class BorrowerRenamedEvent {
    constructor(
        public borrowerName: string,
        public borrowerId: number
      ) {}
}
